import React, { Component } from "react";
import Loader from "../../components/Loader";

class CertificationErrorGateway extends Component {
  componentDidMount() {
    this.props.history.push(
      "/certification/error-guide" + this.props.location.search
    );
  }
  render() {
    return (
      <>
        <Loader />
      </>
    );
  }
}

export default CertificationErrorGateway;
